var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"login-box"},[_c('h1',[_vm._v("登录")]),_c('div',[_c('el-button',{on:{"click":function($event){return _vm.openLoginDialog()}}},[_vm._v("Cookie登录")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }